import Constants from '../actions/types';

const initialState = {
  config: {},
  loading: false,
  error: null
};

const adaptiveMatchingReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.ADAPTIVE_MATCHING_DELETE_CONFIGURATION_REQUEST:
    case Constants.ADAPTIVE_MATCHING_GET_CONFIGURATIONS_REQUEST:
    case Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_REQUEST:
    case Constants.ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case Constants.ADAPTIVE_MATCHING_GET_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload
      };
    case Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload
      };
    case Constants.ADAPTIVE_MATCHING_DELETE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        config: {}
      };
    case Constants.ADAPTIVE_MATCHING_REGENERATE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload
      };
    case Constants.ADAPTIVE_MATCHING_GET_CONFIGURATIONS_FAILURE:
    case Constants.ADAPTIVE_MATCHING_SAVE_CONFIGURATION_FAILURE:
    case Constants.ADAPTIVE_MATCHING_DELETE_CONFIGURATION_FAILURE:
    case Constants.ADAPTIVE_MATCHING:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default adaptiveMatchingReducer;
